import './Footer.module.css';

const Footer = () => {
  return (
    <footer>
      <p>
        (c) memegle. All rights reserved. Powered by&nbsp;
        <a href="https://giphy.com/">Giphy</a>.
      </p>
    </footer>
  );
};

export default Footer;
